import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import TimeLimitContext from '../../context/TimeLimitContext';
import CountryContext from '../../context/CountryContext';

import Navbar from '../../components/Navbar/Navbar';
import Title from '../../components/Title/Title';

import Xicon from '../../img/x.png';
import rosterImg from '../../img/home/roster.jpg';
import build11Img from '../../img/home/build11.jpg';
/* import penaltyImg from '../../img/home/roster.jpg'; */
import tictactoeImgBot from '../../img/home/tictactoe-bot.jpg';
import tictactoeImgLocal from '../../img/home/tictactoe-local.jpg';
import tictactoeImgOnline from '../../img/home/tictactoe-online.jpg';
import WorldLogo from '../../img/WorldLogo.png';
import AfaLogo from '../../img/AfaLogo.png';

import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();
  const { timeLimit, setTimeLimit } = useContext(TimeLimitContext);
  const { numberOfCountries, setNumberOfCountries } = useContext(CountryContext);

  // Estados para los modales y para el mensaje de usuario
  const [showBuild11Modal, setShowBuild11Modal] = useState(false);
  const [showOtherModesModal, setShowOtherModesModal] = useState(false);
  const [showOtherModesModalOnline, setShowOtherModesModalOnline] = useState(false);
  const [showOtherModesModalBot, setShowOtherModesModalBot] = useState(false);
  const [showOtherModesModalPlayerFinder, setShowOtherModesModalPlayerFinder] = useState(false);
  const [showConfigureModal, setShowConfigureModal] = useState(false);

  return (
    <div className="home-page-container">
      <Navbar />
      <Title />

      {/* Contenedor de las cards */}
      <div className="cards-container">
        {/* Primera fila: Tic-Tac-Toe (BOT, LOCAL, ONLINE) */}
        <div className="cards-row tic-tac-toe-row">
          <div className="game-card" onClick={() => setShowOtherModesModalBot(true)}>
            <img src={tictactoeImgBot} alt="Tic Tac Toe Bot" />
            <h2>TIC-TAC-TOE</h2>
            <div className="card-bottom bot">
              <p>(BOT)</p>
            </div>
          </div>

          <div className="game-card" onClick={() => setShowOtherModesModal(true)}>
            <img src={tictactoeImgLocal} alt="Tic Tac Toe Local" />
            <h2>TIC-TAC-TOE</h2>
            <div className="card-bottom local">
              <p>(LOCAL)</p>
            </div>
          </div>

          <div className="game-card" onClick={() => setShowOtherModesModalOnline(true)}>
            <img src={tictactoeImgOnline} alt="Tic Tac Toe Online" />
            <h2>TIC-TAC-TOE</h2>
            <div className="card-bottom online">
              <p>(ONLINE)</p>
            </div>
          </div>
        </div>

        {/* Segunda fila: ROSTER (SOLO) y BUILD11 (SOLO) */}
        <div className="cards-row">
          <div
            className="game-card"
            onClick={() => navigate('/roster', { state: { mode: 'normal' } })}
          >
            {/* Badge NEW en la card de ROSTER */}
            <div className="new-badge">NEW!</div>
            <img src={rosterImg} alt="Roster Solo" />
            <h2>ROSTER</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>

          <div className="game-card" onClick={() => setShowBuild11Modal(true)}>
            <img src={build11Img} alt="Build11 Solo" />
            <h2>BUILD11</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>

{/*           <div className="game-card" onClick={() => navigate('/penalty', {
            state: {
              combinationWinner: 'user',      // o 'bot' 
              startingAction: 'userShoot'     // o 'botShoot'
            }
          })}>
            < img src={penaltyImg} alt="Penalty" />
            <h2>PENALTY</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Bar con emojis */}
      <div className="top-bar">
        <button className="icon-button" onClick={() => navigate(`/ranking`)}>
          <span role="img" aria-label="Ranking">🏆</span>
        </button>
        <button className="icon-button" onClick={() => setShowConfigureModal(true)}>
          <span role="img" aria-label="Configuración">⚙️</span>
        </button>
        <button className="icon-button" onClick={() => setShowOtherModesModalPlayerFinder(true)}>
          <span role="img" aria-label="Búsqueda">🔍</span>
        </button>
      </div>

      {/*
        ======================================================================
        MODALES
        ======================================================================
      */}

      {
        showBuild11Modal && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowBuild11Modal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/squad`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/squad-arg`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModal && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/local`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/local`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModalOnline && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModalOnline(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/room`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/room`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModalBot && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModalBot(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/solo-bot`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/solo-bot-arg`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showConfigureModal && (
          <div className="join-room-modal">
            <div className="join-room-content">
              <div className="join-room-header">
                <h3 className="config-h3">Configure Room (TIC-TAC-TOE)</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowConfigureModal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="join-room-form">
                <label htmlFor="timeLimit">TIME LIMIT PER TURN:</label>
                <select
                  value={timeLimit}
                  onChange={(e) => setTimeLimit(parseInt(e.target.value, 10))}
                >
                  <option value={20}>20 seconds</option>
                  <option value={30}>30 seconds</option>
                  <option value={60}>1 minute</option>
                  <option value={120}>2 minutes</option>
                  <option value={180}>3 minutes</option>
                  <option value={240}>4 minutes</option>
                  <option value={300}>5 minutes</option>
                </select>

                <label htmlFor="numberOfCountries">COUNTRIES:</label>
                <select
                  value={numberOfCountries}
                  onChange={(e) => setNumberOfCountries(e.target.value)}
                >
                  <option value="all">All available countries</option>
                  <option value="top">Only top countries available</option>
                </select>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModalPlayerFinder && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModalPlayerFinder(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/player-finder`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/player-finder-arg`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default HomePage;
